<template>
  <div class="share-container">
    <div class="common-container">
      <div class="common-title">
        <h2>优秀的案例分享</h2>
        <p>行业合作案例分享，共建生态融合的开放平台</p>
      </div>
      <ul class="case-list">
        <li
          class="case-item"
          v-waves
          @click="
            showModel({
              title: '积分商城',
              link: 'https://activity-market.shmedia.tech/questionnaire/toIndex.do?&linkid=4028d0815d88464f015d888a32080016&type=h5&actId=2c9fa4ab759108af01759155e4bd0428&jwid=gh_835d899e19dc&openid=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJmNGYxMmJjM2JjZDQ0YWM1YTRhYjhlYmQ0MWJhN2JmOTszMTAxMDYiLCJpYXQiOjE2MzQyODYzNDQsImV4cCI6MjY3MTA4NjM0NH0.M9g3DDcwAbdwbVU-C5UbiVl-JhqkFzTBwUbkQ-SmK1AyLCiy6Z3e1YY8FPNUjQoO3YvhFj-TQyDL6I1a4QLjFw',
            })
          "
        >
          <h3>积分商城</h3>
          <div
            class="phone bounceInUpSlow wow"
            data-wow-delay="0.1s"
            style="
              visibility: visible;
              animation-delay: 0.1s;
              animation-name: bounceInUpSlow;
            "
          >
            <img src="@/assets/images/share-img01.png" alt="" />
          </div>
        </li>
        <li class="case-item" v-waves>
          <h3>智能检索</h3>
          <div
            class="phone bounceInUpSlow wow"
            data-wow-delay="0.2s"
            style="
              visibility: visible;
              animation-delay: 0.2s;
              animation-name: bounceInUpSlow;
            "
          >
            <img src="@/assets/images/share-img02.png" alt="" />
          </div>
        </li>
        <li class="case-item" v-waves>
          <h3>直播</h3>
          <div
            class="phone bounceInUpSlow wow"
            data-wow-delay="0.35s"
            style="
              visibility: visible;
              animation-delay: 0.35s;
              animation-name: bounceInUpSlow;
            "
          >
            <img src="@/assets/images/share-img03.png" alt="" />
          </div>
        </li>
        <li class="case-item" v-waves>
          <h3>桐梓购物小程序</h3>
          <div
            class="phone bounceInUpSlow wow"
            data-wow-delay="0.5s"
            style="
              visibility: visible;
              animation-delay: 0.5s;
              animation-name: bounceInUpSlow;
            "
          >
            <img src="@/assets/images/share-img04.png" alt="" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script setup>
const showModel = ({ title, link }) => {
  $$.toast({ title, link });
};
</script>
<style lang="less" scoped></style>
